import { render } from "./LazyLoadComponent.vue?vue&type=template&id=41405523&ts=true"
import script from "./LazyLoadComponent.vue?vue&type=script&lang=ts"
export * from "./LazyLoadComponent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\program-list-acom26\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__